export const generateAdvancedSMSCode = (templateName: string) => {
  // Properly escape the template name to prevent code injection
  const escapedTemplateName = JSON.stringify(templateName);

  return `  if conv.caller_number is not None:
    conv.send_sms_template(conv.caller_number, ${escapedTemplateName})
    return "An SMS was sent to the caller"
  else:
    return "An SMS could not be sent to the caller because the phone number is unknown"
    `;
};
